var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemoved = (_ref, ref) => {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "tag-status",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.7 56.7",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 28.8v-1-1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cog",
    d: "M10.1 25.2H13c.5 0 .7-.1.8-.6.4-1.5.9-2.9 1.7-4.2.4-.6.3-1-.2-1.5-.6-.6-1.2-1.2-1.8-1.7-.4-.3-.5-.6 0-1 1-.9 1.9-1.8 2.7-2.7.4-.4.6-.3.8 0l1.9 1.9c.4.4.8.5 1.3.2 1.4-.9 2.8-1.5 4.4-1.8.5-.1.4-.4.4-.7v-2.8c0-.6.2-.8.8-.8h3.8c.6 0 .8.2.8.8v2.9c0 .4 0 .6.5.7 1.5.4 2.9.9 4.3 1.7.6.4 1 .3 1.5-.2.6-.7 1.3-1.3 1.9-1.9.3-.3.4-.3.7 0 1 1 2.1 2 3.1 3 .3.3 0 .4-.1.6l-2.1 2.1c-.4.4-.4.7-.1 1.1.8 1.3 1.5 2.7 1.8 4.3.1.5.3.7.9.7.9-.1 1.9 0 2.8 0 .5 0 .7.2.7.7v3.9c0 .5-.2.7-.7.7h-2.9c-.5 0-.7.2-.8.6-.3 1.6-1 3-1.9 4.4-.3.4-.2.7.1 1.1l2.1 2.1c.2.2.4.3.1.6l-3 3c-.3.3-.5.3-.9 0-.6-.7-1.3-1.3-2-2-.3-.3-.7-.4-1.1-.1-1.4.9-2.9 1.5-4.5 1.8-.4.1-.4.4-.4.7v2.7c0 .6-.2.9-.9.9h-3.7c-.6 0-.8-.2-.8-.8v-2.8c0-.4-.1-.6-.5-.7-1.5-.3-2.9-.9-4.2-1.7-.6-.4-1.1-.4-1.6.2-.6.7-1.3 1.2-1.9 1.9-.3.3-.5.2-.8 0-.9-1-1.9-1.9-2.9-2.9-.4-.4-.2-.6 0-.9.7-.7 1.3-1.4 2-2 .4-.3.4-.7.2-1-.9-1.5-1.5-3-1.9-4.6-.1-.4-.4-.4-.7-.4-.9 0-1.8-.1-2.7 0-.7.1-.9-.2-1-.7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2,2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1 27.9c0-3.5-2.7-6.2-6.1-6.2-3.4 0-6.1 2.7-6.2 6.1 0 3.3 2.8 6.2 6.2 6.2 3.3 0 6.1-2.8 6.1-6.1z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2,2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemoved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/removed.5b3c6dc67da5419e37cfe4c472cd2ace.svg";